// The CMS AuthProvider owns this key. Never send a stale legacy adminToken.
export const getAdminHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const apiError = (error) => {
  if (error.response?.status === 401) return "Η σύνδεσή σας έληξε. Συνδεθείτε ξανά.";
  const detail = error.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "Ελέγξτε τα υποχρεωτικά πεδία της φόρμας.";
  return "Δεν ήταν δυνατή η αποθήκευση. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.";
};
